const getBackendUrl = () => {
  if (process.env.NODE_ENV === 'production') return '';
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE_URL = getBackendUrl();

export const API_ENDPOINTS = {
  programs: `${API_BASE_URL}/api/programs`,
  programDetail: (slug) => `${API_BASE_URL}/api/programs/${slug}`,
  blog: `${API_BASE_URL}/api/blog`,
  blogDetail: (slug) => `${API_BASE_URL}/api/blog/${slug}`,
  contact: `${API_BASE_URL}/api/contact`,
  newsletter: `${API_BASE_URL}/api/newsletter`,
  gallery: `${API_BASE_URL}/api/gallery`,
  team: `${API_BASE_URL}/api/team`,
  donationCheckout: `${API_BASE_URL}/api/donations/checkout`,
  donationStatus: `${API_BASE_URL}/api/donations/status`,
  adminLogin: `${API_BASE_URL}/api/admin/login`,
  adminVerify: `${API_BASE_URL}/api/admin/verify`,
  adminStats: `${API_BASE_URL}/api/admin/stats`,
  adminBlog: `${API_BASE_URL}/api/admin/blog`,
  adminBlogSlug: (slug) => `${API_BASE_URL}/api/admin/blog/${slug}`,
  adminPrograms: (slug) => `${API_BASE_URL}/api/admin/programs/${slug}`,
  adminGallery: `${API_BASE_URL}/api/admin/gallery`,
  adminGalleryId: (id) => `${API_BASE_URL}/api/admin/gallery/${id}`,
  adminTeam: `${API_BASE_URL}/api/admin/team`,
  adminTeamId: (id) => `${API_BASE_URL}/api/admin/team/${id}`,
  adminContacts: `${API_BASE_URL}/api/admin/contacts`,
  adminContactRead: (id) => `${API_BASE_URL}/api/admin/contacts/${id}/read`,
  adminNewsletter: `${API_BASE_URL}/api/admin/newsletter`,
  adminUpload: `${API_BASE_URL}/api/admin/upload`,
  adminCredentials: `${API_BASE_URL}/api/admin/credentials`,
  adminDonationsList: `${API_BASE_URL}/api/donations/list`,
};

export default API_BASE_URL;
